module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C245"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "C250"
  }, [_vm._v("Generations: The Huxleys, 1825–1975")]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_vm._v("The Inheritor")]), _vm._v(" "), _c('p', {
    staticClass: "C289"
  }, [_vm._v("BABY mine, how strange to see")]), _vm._v(" "), _c('p', {
    staticClass: "C289"
  }, [_vm._v("Other faces blent in thine,")]), _vm._v(" "), _c('p', {
    staticClass: "C289"
  }, [_vm._v("Other greatness touching thee,")]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_vm._v("Baby mine.")]), _vm._v(" "), _c('p', {
    staticClass: "C289"
  }, [_vm._v("Something in a curve or line")]), _vm._v(" "), _c('p', {
    staticClass: "C289"
  }, [_vm._v("Here revives thine ancestry:")]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_vm._v("Each on thee has laid his sign.")]), _vm._v(" "), _c('p', {
    staticClass: "C289"
  }, [_vm._v("And thyself? Ah! thou for me")]), _vm._v(" "), _c('p', {
    staticClass: "C289"
  }, [_vm._v("Shall this heritage enshrine;")]), _vm._v(" "), _c('p', {
    staticClass: "C289"
  }, [_vm._v("All I was not, thou shalt be")]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_vm._v("Baby mine!")])]), _c('p', {
    staticClass: "C288"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Leonard Huxley, ‘The Inheritor’, in "), _c('em', [_vm._v("Anniversaries and Other Poems")]), _vm._v(" (London: John Murray, 1920), 54."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2116",
      "id": "id_2115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "P25t"
  }, [_vm._v("The night that Leonard Huxley became a father, he transformed the wonder into poetry. For no one but himself, he penned ‘The Inheritor’ to mark the birth of Julian Sorell Huxley in 1887. The awe and the worry of reproduction and family lines, of descent, breeding, inheritance and heritage were on Leonard Huxley’s mind. In the baby’s face ancestors were reborn: perhaps Leonard’s own father Thomas Henry; perhaps the other grandfather, the doctrinally troubled Tom Arnold; perhaps the baby’s great-grandfather, headmaster, historian, Thomas Arnold. ‘Other greatness’ from the Huxleys and the Arnolds had been revived with the miracle that was grown by Julia Arnold Huxley and birthed that summer night, 1887. None of it was yet thought of as ‘genetics’, let alone ‘Mendelian inheritance’, but it soon would be: the newborn would be one of the key actors in that reworking of ‘breeding’, and of ‘pedigree’.")]), _vm._v(" "), _c('div', {
    staticClass: "C226"
  }, [_c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('img', {
    staticClass: "img80",
    attrs: {
      "alt": "",
      "src": "html/images/44_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.1: Thomas Henry, Leonard, Julian Huxley, 1895.")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Over these three generations – the Victorian, the Edwardian and the Modern – the Huxley fortunes rose, and their legacies flourished, publicly and privately. Yet Leonard Huxley was long subject to Thomas Henry Huxley’s oppressive greatness. So too his beautiful newborn Julian would grow up, then step up and into the spectacular scientific position that Thomas Henry Huxley had single-handedly conjured, if not out of thin air, certainly out of not much. Julian did inherit a good visage from his Huxley and Arnold families, just as he inherited their inclination to reading and writing poetry (")]), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_4"
    }
  }, [_vm._v("figure 1.1")]), _vm._v("). But Julian the Inheritor also absorbed and carried forward his father’s self-recrimination vis-à-vis Thomas Henry: ‘all I was not’. On the night of his birth, even as he came out of his mother and into the world, Julian Sorell Huxley had the expectations of his line bestowed upon him. Leonard’s private longing was to become his own weight to bear.")]), _vm._v(" "), _c('p', {
    staticClass: "C292"
  }, [_vm._v("VICTORIANS: THOMAS HENRY HUXLEY AND HENRIETTA HEATHORN")]), _vm._v(" "), _c('p', {
    staticClass: "P25"
  }, [_vm._v("Thomas Henry Huxley, unlike his son Leonard, was not inclined towards his familial forebears. Rather he tended to distance himself from them, even cut himself off. He found little satisfaction in either looking or going backwards in most matters. At the height of his career, his interest in the past lay more in the pedigree of "), _c('em', [_vm._v("Homo sapiens")]), _vm._v(" than in the Huxleys. Looking forward, however, he willed himself to be patriarch of a new dynasty, as well as a new science. And he was."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2114",
      "id": "id_2113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("When Huxley did look back, it was not far, and it was to his mother, not his father. ‘Physically and mentally I am the son of my mother so completely . . . that I can hardly find any trace of my father in myself.’ Rachel was London-born and had five surviving children before Thomas Henry was born in May 1825, in Ealing. She was forty, unusually old to "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("be bearing children in the 1820s. He wrote of her wit and her quickness. From his mother, by Huxley’s own account, he acquired ‘piercing black eyes’, ‘rapidity of thought’, ‘excellent mental capacity’ and very little modesty."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2112",
      "id": "id_2111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" He was devoted to her. Less so to his father George Huxley, who was a teacher. The Ealing School was on the decline even as George Huxley taught there between 1807 and 1835 and certainly in the brief time that his son was a student. Thomas Henry enrolled when he was eight, in 1833, and left two years later, the worst society he had ever known, he recalled."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2110",
      "id": "id_2109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Remarkably – especially given how entwined the Huxleys were to become with education – this was his sole experience of school. Huxley finances spiralled down along with Ealing School’s, and eventually George resigned and took his wife and children to Coventry, where his family had originated.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("That was in 1835, a Midlands time and place foundational to Huxley’s political and philosophical inclinations."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2108",
      "id": "id_2107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" We might imagine an industrializing town, nestled up to Birmingham. Yet this was not a factory town, even though, or really because, Coventry was the home of silk weavers and manufacturers of ribbons. Several steam looms were introduced in the 1830s, but the town’s masters, journeymen and apprentices were cautious, independent craftsmen more troubled than enabled by the great industrial changes sweeping across the Midlands. Coventry battled poverty and inequity and it did so partly through a long tradition of dissenting politics. T. H. Huxley’s signature opposition to establishment authority started here. It was a town where privilege and convention were questioned, almost as a matter of course. In Coventry over the 1830s and 1840s, there were Chartists, there were freethinkers and secularists, and there were phrenologists. There was the socialism of second-generation Owenism, especially championed by Charles Bray, a Coventry ribbon manufacturer, busy publishing on new mechanisms for working-class education and improvement, on a new kind of social science, and on "), _c('em', [_vm._v("The Education of the Body: An Address to the Working Classes")]), _vm._v(" (1836). For young Thomas Henry Huxley, this Coventry culture was a primer in the critique of orthodoxy. He set himself determined rituals of self-instruction, monumental by any measure, consuming a whole range of political philosophies that grounded his later actions, and indeed formed his very self.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("For a boy born into both class and financial decline, reading was worthy and, as it turned out, a good investment over many long nights, but it brought no income. Not working-class, but financially struggling to fit into a lower middle class, Huxley pursued his own ‘education of the body’ as a young medical apprentice."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2106",
      "id": "id_2105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" His two sisters happened to each marry medical men in 1839, and this set a course both for himself and for his elder brother James (Jim). His long-favoured sister, Lizzie, married John Salt, who apprenticed Jim. And Huxley was apprenticed to the other brother-in-law, John Cooke, at just thirteen. In 1841 Huxley followed this half of the family to London – the two sisters, his medical brothers-in-law and brother Jim. There, he was re-apprenticed to Thomas Chandler in the miserable Docklands. Over his lifetime and through dogged hard work, Huxley was to extract himself and his wider suite of semi-hopeless siblings from family financial and social decline. But at this point, he was indebted to his brothers-in-law and his elder brother George, who funded much of his medical education in London. With University College initially out of reach, Huxley first attended Sydenham College, surrounded by medical radicals. With Jim he later gained enrolment at Charing Cross medical school in September 1842, both as ‘free scholars’. Huxley had something to prove. By 1845 he took University College’s "), _c('a', {
    attrs: {
      "href": "#/html/09_PART_I__Genealogies#page_1"
    }
  }, [_vm._v("Part I")]), _vm._v(" Bachelor of Medicine examination and won a gold medal for anatomy and physiology. He was ambitious and he was all-in.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("It heralded a bright future, but what income was to be had? He needed to work – and quickly – to repay debts for his medical education and training. In 1846 Huxley was commissioned to the Royal Navy’s HMS "), _c('em', [_vm._v("Rattlesnake")]), _vm._v(" as assistant surgeon. Under Captain Owen Stanley’s command, the instructions were to explore New Guinea, and the Torres Strait, north of Australia, and to chart the Louisiade Archipelago as yet unexplored by the British Navy. For the twenty-one-year-old, this was to be life-changing, his own Melanesian coming-of-age. Even before departure, Huxley was catapulted into a whole new company: erratic Stanley introduced Huxley to Richard Owen, the great comparative anatomist of the era who a decade later was to become Huxley’s intellectual nemesis. He met John MacGillivray, the "), _c('em', [_vm._v("Rattlesnake")]), _vm._v("’s naturalist, Oswald Brierly, the expedition’s "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("artist, and the surgeon John Thompson. Thomas Henry Huxley was poised between medicine and natural science, and for years he could have gone either way.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "P29"
  }, [_vm._v("The ship departed after a long preparation for what ended up a four-year voyage. Sailing in chilly December 1846 from Portsmouth, HMS "), _c('em', [_vm._v("Rattlesnake")]), _vm._v(" returned to Chatham in November 1850. Sydney was the base for the expedition’s numerous cruises north to Cape York, to the Torres Strait and to the islands of Melanesia. And while poor Captain Stanley fell ill and died in Sydney – in young Huxley’s arms – Huxley himself fell into other arms. He met the woman with whom he was to reproduce a scientific dynasty, and through whom he could become the patriarch he aspired to be, looking forwards not backwards in time.")])]), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Long-lived Henrietta Heathorn (1825–1914) came from an altogether more complex family than Huxley, daughter of Kent brewer and sometime merchant seaman Henry Heathorn and Caribbean-born Sarah Richardson. Sarah was in fact married to someone else at the time, a man with whom she had (at least) two children already, Oriana and Isabel (or Isabella). Henrietta’s place of birth is unclear but may have been in the West Indies, possibly Jamaica given Sarah Richardson’s preexisting connections. But there are no birth records for Henrietta Heathorn because she was illegitimate, Sarah having eloped with Henry Heathorn, a difficult fact that Henrietta was shocked to discover late in life."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2104",
      "id": "id_2103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Born in 1825, Henrietta was the same age as Huxley, but as a young person was far more travelled than he, and more formally educated. If Huxley moved from London to Coventry and back to London in his childhood and youth, Henrietta Heathorn travelled much further in her early years, following her father’s multiple and mostly unsuccessful business ventures from the West Indies to England and then to the Australian colonies. She was fortunate to spend late-childhood years in Kent with an aunt, Catherine Heathorn, through whose initiative she received thorough if unconventional schooling. Catherine Heathorn happened to be a subscriber to the London Association for Moravian Missions, and through contacts and family funding secured Henrietta’s enrolment in a boarding school, the Moravian Settlement, in Neuwied on the Rhine near Koblenz. Henrietta was educated there "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("between the ages of fifteen and seventeen, over 1840–42, the years when Thomas Henry was apprenticed in Coventry and then London. Their contexts could not have been more different. While Huxley was miserably dissecting and dispensing by day and teaching himself German and Ancient Greek by night, Henrietta was being taught basic natural sciences, arithmetic, Latin, German and French by the Moravian sisters, the as-yet-unmarried women of the community. The Moravians endorsed significant mental as well as physical education for girls as well as boys; in 1841 there were seventy boys and around fifty girls."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2102",
      "id": "id_2101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" Henrietta was also absorbing a particular form of Protestantism, even as young Huxley was being led away from God altogether by Coventry secularists, pan-theists and a-theists, and by Sydenham radicals. Yet the Moravians were tolerant of denominational differences – ecumenical – and stressed personal piety and the intimate experience of faith, all significant for Henrietta’s future life with Huxley. Tolerance for his agnosticism was perhaps seeded in her German boarding school.")]), _vm._v(" "), _c('p', {
    staticClass: "C279"
  }, [_vm._v("In 1843 Henrietta moved to New South Wales, where her father had just taken on the Woodstock Mills in Jamberoo, a remote hamlet, barely that, in the coastal hinterlands south of Sydney. He was milling rainforest timber in what was still – but only just – a penal colony built on convict labour. Jamberoo was a difficult place to live – snake-infested and frontier – and when her half-sister Oriana married merchant William Fanning, Henrietta moved into their comfortable house in Newtown, Sydney. But she kept the house as much as lived in it, sometimes imagining herself as Cinderella, the obedient servant-relative.")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("She was the last of sisters three,")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("Fair, golden-haired, a merry maid . . .")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("She journeyed to a distant land,")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("With waters blue, and sunshine bright,")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("Where lofty columned palm-trees stand,")]), _vm._v(" "), _c('p', {
    staticClass: "C297"
  }, [_vm._v("And moonbeams make a day of night.")]), _vm._v(" "), _c('p', {
    staticClass: "C299"
  }, [_vm._v("But Cinderella – as she titled this poem – had a higher destiny. And there he was on the deck of the "), _c('em', [_vm._v("Rattlesnake")]), _vm._v(", the brooding and melancholy prince.")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Twelve moons had waned, there came a youth")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "C296"
  }, [_vm._v("Fate wafted to this self-same shore")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("A princely soul who sought for truth")])]), _c('p', {
    staticClass: "C297"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("And honour too – but truth still more."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2100",
      "id": "id_2099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("The prince (whom she called ‘Hal’) and Henrietta (whom he cast less as Cinderella and more as Jane Eyre)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2098",
      "id": "id_2097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" met at a Sydney government-house ball, where they fell hopelessly and instantly in love. They danced on the deck of the "), _c('em', [_vm._v("Rattlesnake")]), _vm._v(", they picnicked on sparkling Sydney harbour foreshores, and Huxley became the favoured visitor at the Fannings’ house. For Huxley – perhaps for both of them – there followed a love-sickness, for just as they discovered one another, the "), _c('em', [_vm._v("Rattlesnake")]), _vm._v(" departed for yet another long northern cruise. Young and stricken with love, he gifted a portrait locket of himself to Henrietta. She was rapturous in gratitude at the token, but little did she know that this image was to substitute for his own vital self, and for too long."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#page_428",
      "id": "id_2096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" As letters slowed from the "), _c('em', [_vm._v("Rattlesnake")]), _vm._v(", the treasured portrait-locket was all that was left of him, like a relic. Theirs was a long and tortured engagement, intimacy deferred by his naval obligations, the interminable "), _c('em', [_vm._v("Rattlesnake")]), _vm._v(" cruises, and his return journey to England.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Back in London, Huxley was as committed to the Royal Navy as he was to Henrietta. He was also committed to the Malthusian-derived cultural convention that prospective husbands defer marriage until they are able to provide adequately. As things stood, he could not, and it took him five further years over the early 1850s – he in London, she in Sydney – to secure an income adequate to his own expectations.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("In London, Huxley took leave from the navy to write up various findings, committed to pursuing not the medical practice of his naval appointment, but the by-product, natural science. His work in marine biology was fairly swiftly published in the "), _c('em', [_vm._v("Transactions of the Royal Society")]), _vm._v(", and he wrote to Henrietta in February 1851 that ‘FRS . . . is nearer than one might think – to my no small surprise’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2095",
      "id": "id_2094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" He was indeed elected into a precocious Fellowship of the Royal Society that year, followed by its medal in physiology (1852). His star was rising, but no job with it. Despite his publishing success and affirmation by the Royal Society, Huxley was passed over for a sequence of positions any one of which would have offered a decent salary. In a sequence of minor "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("humiliations, he failed to secure a position at the universities of Toronto, Aberdeen, Cork and Kings College, London (where his grandson Julian was to pick up a professorship seventy years later, with notable ease). The prospect of a professorship in natural history at the new University of Sydney also came to naught. Henrietta was getting word from other members of the family that her Hal was ‘anxious and depressed’."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2093",
      "id": "id_2092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" He was. But finally, in a rush, it all fell into place. In July 1854, he secured a lectureship in natural history at the Government (later Royal) School of Mines associated with the Geological Survey in London. His offer was ‘Paleontologist and Lecturer on Natural History’, and although he later said he refused the first element of the title, imagining himself uninterested in fossils, in fact he held this post for thirty-one years."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2091",
      "id": "id_2090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" At long last, Huxley had a good salary intact, strongly supplemented by external lecturing and by writing. His state of indebtedness was over, and he gradually became the Huxley to whom others turned for financial support, even rescue. He was ready to marry, and Henrietta sailed from Sydney at the end of 1854, arriving in May 1855.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Thomas Henry and Henrietta Ann wed on 21 July 1855 in the Anglican All Saints Church, Finchley Road. For all her own complex heritage, the match provided a fresh starting point for a new dynasty. Malthus had instructed young men to delay marriage – which Huxley had – and thereby to reproduce fewer children – which he did not. Henrietta bore eight. The firstborn came on New Year’s Eve 1856, at midnight recalled Henrietta: ‘coming at Christmas I named him Noel’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2089",
      "id": "id_2088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Then came Jessie Oriana, artist Marian – Mady – who was to marry the celebrated portraitist John Collier, Leonard, father of Julian, Rachel, singer Henrietta, doctor Henry and the youngest, Ethel, who – scandalously and illegally so far as English law and conventions were concerned – also married John Collier after the untimely death of her older sister.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("For Huxley and Henrietta, Marian’s death in 1887 (the year that Julian was born) was the second great family tragedy, since firstborn Noel had long before died from scarlet fever in December 1860, four years old. Mortality might have been commonplace for the Victorians, but Henrietta mourned deeply and for years. A great friend, the Rev. Charles Kingsley, gave her a book of his sermons for contemplation, and it is clear that Henrietta’s faith did console. At the same time, "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Huxley’s soon-to-be-named ‘agnosticism’ was hardened in conversation with Kingsley, and literally at the graveside as the tiny coffin was being lowered. He was honest with his grief – there was no ‘Victorian’ suppression of emotion – yet Huxley managed to get on with things. Henrietta’s grief, however, was disabling. One stint at recovery was at the home of new friends, the Charles Darwins. ‘Ah! life’s music fled with him!’ Henrietta mourned in her poem ‘Now and Then, 1860’."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2087",
      "id": "id_2086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("This mid-Victorian generation of Huxley children grew up in St John’s Wood. After Noel’s death they moved to 26 Abbey Place and then in 1872 purchased 4 Marlborough Place. Their neighbourhood boasted any number of mid-Victorian intellectual and literary celebrities, especially importantly for Huxley the philosopher Herbert Spencer."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2085",
      "id": "id_2084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" They were neighbours also with ‘George Eliot’ and George Lewes. Huxley visited the unmarried couple and the exciting philosophical and literary circle around their home, but disapproving Henrietta did not."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2083",
      "id": "id_2082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" In St John’s Wood, as the Huxley children grew up, the Victorian couple hosted well-known Sunday ‘tall teas’, welcoming all kinds of literary and scientific Londoners and international visitors to their own home. But Huxley’s health was not good, and in 1891, when their children were all married – or had died in untimely ways – Henrietta and Huxley retired to Eastbourne, to a house that son-in-law Frederick Waller had designed. Huxley died there, not an old man, in 1895, Henrietta in 1914.")]), _vm._v(" "), _c('p', {
    staticClass: "C292"
  }, [_vm._v("EDWARDIANS: LEONARD HUXLEY AND JULIA ARNOLD")]), _vm._v(" "), _c('p', {
    staticClass: "P25"
  }, [_vm._v("Thomas Henry left a line of Huxleys with more opportunity, more money and more institutional education than he had ever received from his own socially and financially declining forebears. Huxley had almost no schooling, and had presented himself for medical examinations and qualifications through an apprenticeship and sheer hard work. His children, by contrast, were highly and formally educated. The sons, and as it turned out grandsons, studied at Oxford. The girls studied at the Slade School of Fine Art. It all signalled a stunning "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("middle-class leap from Huxley’s Coventry and London-based medical apprenticeship and nocturnal self-instruction.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Leonard Huxley was the middle child and the eldest surviving son, granted his name because it ‘held our lost Noel’s’."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2081",
      "id": "id_2080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" Poor Leonard had the parents’ grief written into his very newborn self. Psychoanalytically literate Julian was later horrified. Leonard’s own childhood – and especially his educational path – was as different from his father’s self-instruction as it was possible to be. His was the generation which benefited from, rather than duplicated, the patriarch’s rise, but which also had to endure expectations of new standards and of more conventional advancement. Leonard attended University College School, Gower Street, part of the nonconformist educational structure and culture of University College London, which aligned with Huxley’s anti-authoritarian politics and his opposition to the Established Church. Leonard then studied at St Andrew’s University and finally graduated from Balliol College, Oxford, at a time when its Broad Church affiliation was affirmed by the Master, Benjamin Jowett."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2079",
      "id": "id_2078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" While there was no scientist within Leonard, there was a man of letters – of classics, of poetry and of literature. He became assistant master at the grand Charterhouse School in Godalming, Surrey, teaching classics. Later he worked in publishing as assistant editor of "), _c('em', [_vm._v("Cornhill")]), _vm._v(" magazine from 1901, and as its editor from 1916. "), _c('em', [_vm._v("Cornhill")]), _vm._v(" was a literary magazine whose initial success was the serialization of distinguished Victorian authors: Elizabeth Gaskell, Anthony Trollope and Henry James, for example. It had also published "), _c('em', [_vm._v("Culture and Anarchy")]), _vm._v(" in the late 1860s, a series of essays by the renowned poet Matthew Arnold.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Thomas Henry Huxley and Matthew Arnold were well acquainted. Over the 1870s, they exchanged books – their own and others’. Matthew Arnold expressed sympathy with a range of Huxley’s views, predicting an imminent religious revolution as significant as the Reformation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2077",
      "id": "id_2076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" They discussed Spinoza. They discussed ‘the character of Christ’. They discussed Hume, as well as Huxley’s "), _c('em', [_vm._v("Hume")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2075",
      "id": "id_2074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Yet through all this, little did they know that the Huxley and Arnold families would be joined in matrimony, a match that grafted two rising dynasties of Victorian science and letters.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("When Leonard was at Oxford he met smart Julia Arnold (1862–1908) one of the first students at the new Somerville College for women. "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Granddaughter of Thomas Arnold of Rugby, daughter of Tom Arnold, sometime chair of English literature in Dublin, niece of Matthew Arnold, she was, naturally, reading English literature. Her sister was the learned novelist Mary Arnold, later Mary Augusta Ward, who published with stratospheric success under the unlikely name Mrs Humphry Ward.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Leonard and Julia married in 1885, and after she had borne all their children – Julian Sorell (1887), Noel Trevenen (Trev) (1889), Aldous Leonard (1894), Margaret Arnold (1899) – Julia Huxley continued the educational endeavours of her father and grandfather, but in a completely different manner, method and style. In 1902, she took an alternative educationist’s path and started her own progressive school for girls in Surrey, calling it Prior’s Field. This was no Rugby and no Charterhouse, from which Leonard resigned in 1901. It was certainly no Moravian boarding school. It was liberal and non-sectarian. It was progressive and adventurous, both for Julia and her boarding girls. Julian, Trev and especially the younger Aldous and Margaret grew up in rural Surrey alongside the Prior’s Field girls, in the splendid modern Arts & Crafts house and school designed by C. F. A. Voysey. The young Huxleys shared their mother, and much of their familial and domestic space, with multiplying boarders and a few day girls, some of them Huxley cousins (")]), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_15"
    }
  }, [_vm._v("figure 1.2")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Leonard and Julia Huxley led active and pastoral lives with their four children and their many domestic animals. By all their accounts, it was easy and pleasant: they walked, swam, cycled, rode and read. Leonard, Julia and their four children took long summer holidays with both sets of extended families. They visited Huxley and Henrietta – Pater and Gran’ moo – in Eastbourne. Leonard took Julian and Trev mountaineering in France and Switzerland – they were skilled and athletic. And they summered with Julia’s sisters, especially Mary Augusta Ward in her grand Hertfordshire home, Stocks. And from those summers, the English novel-reading public enjoyed versions of the Huxley children, the Julian-inspired character ‘Sandy’, for example, in Mrs Humphry Ward’s "), _c('em', [_vm._v("The History of David Grieve")]), _vm._v("; ‘a most delightful imp’, grandfather Huxley wrote to her."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2073",
      "id": "id_2072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" The three Huxley boys were wide-eyed and pretty, impossibly so. There was nothing yet inherited of Thomas Henry Huxley’s signature scowl ("), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_16"
    }
  }, [_vm._v("figure 1.3")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "C226"
  }, [_c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('img', {
    staticClass: "Image103",
    attrs: {
      "alt": "",
      "src": "html/images/55_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.2: Prior’s Field School, "), _c('em', [_vm._v("c")]), _vm._v(". 1909.")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('div', {
    staticClass: "C226"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('img', {
    staticClass: "Image103",
    attrs: {
      "alt": "",
      "src": "html/images/56_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.3: Trevenen, Aldous and Julian Huxley, "), _c('em', [_vm._v("c")]), _vm._v(". 1897.")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Leonard and Julia were comfortable enough to employ a governess-tutor to look after them, who was almost always German and charged with their fluency. ‘I shall expect you to say everything in German soon,’ Leonard wrote to his young boys Julian and Trev in 1896."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2071",
      "id": "id_2070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" The littlest, Aldous, had some way to go. ‘Liebe Mutter,’ the four-year old wrote to his mother in 1898, on holiday again at Aunt Mary’s. ‘I like Laleham’s house better than Stock, liebe mutter ich liebe Frl Ella, ich liebe mein Laleham’s presents, mein solders, my horse and my clown. I am very good indeed, I kiss you, Aldous’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2069",
      "id": "id_2068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_18"
    }
  }, [_vm._v("figure 1.4")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("German literacy, literature, philosophy and science remained intergenerationally important to the Huxleys, as writers and as scientists. But the manner in which this generation acquired it was just one marker of change and upward class mobility. No governess or tutor for the struggling Midlands Huxley of the 1830s. He had had to teach himself German, and did so diligently and effectively. He read German science as well as German philosophy throughout his life, beginning with Goethe, another poet-scientist. This made him an important conduit between English and German ideas and a translator of major biological and zoological texts into English. Henrietta’s fluency was probably superior, from her Moravian schooling. They early shared German philosophy, he courting her with a precious twelve-volume set of Schiller’s works, her favoured poet. Sometimes Huxley would make a show of criticism of her translations yet relied often enough on her skill. It was she who translated lines from Goethe for his much-discussed and unlikely first article in the original issue of "), _c('em', [_vm._v("Nature")]), _vm._v(", which was more poetry than science."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2067",
      "id": "id_2066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Julian was to continue that tradition of engagement with German science and literature. As a young biologist he spent long periods in German laboratories getting up to speed with the latest in Mendelian genetics, the next-generation knowledge that was momentarily to throw Darwin’s ideas asunder.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Despite Thomas Henry Huxley’s capacity to turn around a familial decline in the mid-nineteenth century, and despite the inheritance of his stellar scientific name, Leonard’s Edwardian generation was certainly not standing to inherit any notable wealth. Leonard and Julia’s family were middle-class, without a doubt more comfortable than Huxley’s family of origin. But they nonetheless struggled to maintain the display of social and domestic standing expected of them by others and by themselves. Certainly, they had to work and constantly to reckon income and expenses. Little could be taken for granted in Leonard and Julia’s household. Their sons were launched into a privileged educational realm – Eton – but only just, and only via scholarships. With back-up Rugby plans, first Julian and Trev successfully gained scholarships, and then Aldous, who ‘just scraped in’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2065",
      "id": "id_2064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" ‘What should we do if the boys were stupid, & had no chance of getting scholarships?’ Julia wrote to sister Mary in 1899, worrying again and hovering over their results: ‘Julian began the term by being 3rd then 2nd now has got top again & keeps there steadily . . . Trev has been top & 2nd in his new form & is really doing splendidly in mathematics.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2063",
      "id": "id_2062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" When Julian was undecided on science "), _c('em', [_vm._v("versus")]), _vm._v(" letters, Julia signalled his dual heritage, classics from his father, biology from his grandfather: ‘It would have been very nice if you could have stuck to classics, & got it. However Biology must come out I suppose, like measles or chickenpox.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2061",
      "id": "id_2060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" In 1902 she was pleased that Julian’s grades and form had jumped, but he should be able to do even better. ‘I don’t see why Huxley "), _c('span', {
    staticClass: "Underline"
  }, [_vm._v("cum")]), _vm._v(" Arnolds shouldn’t manage it! There’s good blood in you on both sides, & that means staying power, wh. is everything. All the same don’t over work yourself to please an ambitious mother.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2059",
      "id": "id_2058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" It all turned out well enough, especially when it came to Aldous. ‘Congratulations on being top,’ big brother Trev encouraged little Aldous. ‘I expected you would pick up well when you had got over the first week of loneliness.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2057",
      "id": "id_2056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" The brothers exchanged strategies for coping at Eton ("), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_20"
    }
  }, [_vm._v("figures 1.5")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_21"
    }
  }, [_vm._v("1.6")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "C226"
  }, [_c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "html/images/58_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.4: Mary Augusta Ward, née Arnold, with Aldous Huxley, at Ward’s Hertfordshire house, Stocks.")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Julia Arnold Huxley relied on Mary Ward to keep the household together, including servants, as they struggled on Leonard’s salary and occasional income from writing. She drew on her sister’s novel-derived as well as matrimonially derived affluence, money freely given by one sister to another. Julia worried a good deal, and clearly it was her responsibility, not Leonard’s, to manage the household books. She shared her anxieties as well as her budgets with Mary Ward regularly, withholding both advice and loans from Leonard, especially regarding the money borrowed to keep Prior’s Field buoyant. She turned to Mary for far more mundane matters as well. Might she borrow £25 for the doctors’ bills, she asked her sister in 1898, especially those for sickly Aldous: ‘he is so thin and weak, poor mite’."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2055",
      "id": "id_2054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" These next-generation Huxleys, seemingly well-to-do, were in debt, and not just to the doctor, but shamefully even to the butcher and the grocer. Sensibly, they should not be having another baby, but she longed for a girl, and Margaret was soon added to the household ("), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_23"
    }
  }, [_vm._v("figure 1.7")]), _vm._v("). ‘Of course we are living beyond our income.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#page_429",
      "id": "id_2053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" So much for Malthus.")]), _vm._v(" "), _c('div', {
    staticClass: "C226"
  }, [_c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "html/images/60_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.5: Julian to Trev and Aldous Huxley, 20 October 1906.")])])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('div', {
    staticClass: "C226"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "html/images/61_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.6: Julian Sorell Huxley at Eton.")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Scholarship pressures continued into the brothers’ university years. There was no other way that they could follow Leonard’s (and Great Uncle Matthew Arnold’s) footsteps to Balliol. Julian secured the Brackenbury Scholarship to study zoology (1906–9), and Trev expanded his splendid talent for mathematics at Oxford from 1908. They were the elder pair, tall, fit and wiry, climbing Oxford’s spires together as they had the Alps with their father. Aldous followed at a distance, first at Eton, then at Balliol, where he read English Literature from 1913. ‘Little’ brother of the three, Aldous grew to six feet four and half inches, the tallest of these long-limbed Huxley brothers.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("There seems to have been wide affection, both within this immediate family as with the wider family, but also difficult separations. In the years that Sigmund Freud was thinking through the connection and individuation of mothers, fathers, infants and children, the Huxley boys were routinely separated from Julia and Leonard, and from each other. First Julian, then Julian and Trev, then Julian, Trev and Aldous, were sent away to various aunts while their mother was confined to give birth at Goldaming, often to Aunt Mary Ward’s. Then, when she had completed her own biological family, Julia took in and taught the girls of others. Her considerable energy and attention were consumed by her school and ‘her girls’, impressively so, sometimes poignantly so. Underneath the Huxley children’s memories of ease, pleasure and leisure there was more going on. At Eton, Julian missed his mother painfully and sensed her focus on her girls. He confessed to hating Eton, but routinely she was too busy with Prior’s Field matters to make visits, describing all the new girls in detailed letters and then apologizing for not coming up to Eton."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2052",
      "id": "id_2051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" Indeed Prior’s Field went from strength to strength, and she delighted in announcing its success. Writing to sister Mary in 1908, she was proud that Julian was about to go up to Balliol, and in the next breath detailed her own achievements: ‘The school is absolutely packed 59 boarders, 6 day girls.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2050",
      "id": "id_2049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('div', {
    staticClass: "C226"
  }, [_c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('img', {
    staticClass: "Image103",
    attrs: {
      "alt": "",
      "src": "html/images/63_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.7: The first page of Prior’s Field’s albums of historic photographs. Julia and Aldous Huxley, 1898, and Margaret Huxley, age three, miniature by John Collier, "), _c('em', [_vm._v("c")]), _vm._v(". 1902.")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('div', {
    staticClass: "C226"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "html/images/64_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.8: Julia Arnold Huxley, the New Woman, "), _c('em', [_vm._v("c")]), _vm._v(". 1902.")])])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Edwardian Julia Arnold was no Victorian Henrietta Huxley. If Henrietta had imagined herself as Cinderella, clingingly dependent on her own ‘prince’, and Huxley had imagined her as Jane Eyre, the governess figure seeking the legitimacy and purpose of the patriarch husband, Julia Arnold of Somerville College held her own authority, learning and confidence. She was very sure of herself. Bespectacled in one stunning portrait, her glasses were not just for reading, but a symbol to be read: Julia Arnold Huxley was a New Woman (")]), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_24"
    }
  }, [_vm._v("figure 1.8")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("And then she died. It was painful and it was too early. Julia noted a small lump in her left breast in early 1906. It was treated with belladonna by her local doctor, then homeopathically by Charles Thomas Knox Shaw, recommended to her as the ‘best Homeopath in Town’. By 1908 she was having electrical treatment, the new röntgenotherapy named for Wilhelm Röntgen, who had discovered X-rays just a decade before Julia’s illness."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2048",
      "id": "id_2047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Well might we shudder. Leonard had to write to poor Julian at Oxford that his mother was declining: ‘very weak & sometimes not clearly conscious . . . You must attune your mind, dear boy, to the sad expectation of hearing with the next 48 hours that the end has come, tranquilly I trust & believe, in sleep & peace.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2046",
      "id": "id_2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" As it was, Julia held on for another eleven days, and died on 29 November 1908, aged forty-six. She was with Leonard and her much-loved sister as she passed into the next life, or as she herself said to Mary, into ‘the next stage of this – because after all it is only one life right on thro’ eternity’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2044",
      "id": "id_2043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "C292"
  }, [_vm._v("MODERNS: JULIAN HUXLEY AND JULIETTE BAILLOT")]), _vm._v(" "), _c('p', {
    staticClass: "P25"
  }, [_vm._v("Julian Huxley was a student at Oxford when his vital mother passed away in November 1908. He completed his studies in 1909, and his early career in biology fell as easily into place as his grandfather’s attempts to enter natural sciences professionally had been blocked and difficult. It was not solely because of his grandfather’s name and fame that Julian’s zoological path was clear, but certainly partly so. All manner of opportunities and connections came his way. In June 1909, fresh from Oxford, he was invited to attend the Charles Darwin Centenary "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("in Cambridge, an anniversary of his birth in 1809 as well as of the publication of "), _c('em', [_vm._v("On the Origin of Species")]), _vm._v(" in 1859. It was a family affair, as much as a scientific one. Long-lived survivors of Charles Darwin’s own generation attended, including Henrietta Huxley.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("While Darwin the man was memorialized in 1909, his actual ideas were just then at a low point, as later chapters will explain. The next generation of zoologists, only too aware of some problems with Darwin’s thesis on natural selection, was making major breakthroughs. Julian was party to much of this new work, in which evolution and genetics were rubbing up against one other. First, from September 1909, he went to Naples for a year to work at the Stazione Zoologica, where his grandfather had also spent time. Then, from October 1910, he gained a lectureship at Balliol and a demonstratorship in Oxford’s Department of Zoology. While his grandfather had craved such appointments as a young man, it all fell into Julian’s lap, or so it would seem. By 1912 he was offered the Chair of Biology at the new Rice Institute, Houston, Texas, lured by a salary far beyond meagre Oxford offerings. It had been under discussion at least since late 1910, when the biologist Edwin Conklin from Princeton was asked for his opinion on Julian Huxley by Rice Institute’s first president, Edgar Odell Lovett. ‘Charming,’ Conklin confirmed, ‘with many of the qualities of his grandfather.’ Princeton University, via Conklin, in fact also pursued Julian over 1911, to the point of an informal offer – Julian asked him just what 2,500 dollars per year was in pounds. Conklin presumed that Princeton would win out since Julian was accustomed to ‘an ancient academic center’. But Julian indicated that ‘the very newness & remoteness’ of Rice, in Houston, was precisely what attracted him."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2042",
      "id": "id_2041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" Lovett won the day and the Huxley prize. It was a coup. Julian indicated that he wanted to spend time in German laboratories first, but that he would attend opening ceremonies in the autumn of 1912.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("All seemed promising, even glowing, for the Inheritor. But the following few years were very difficult indeed, and almost nothing fell into place for the too-sensitive Julian. Indeed, everything fell apart. While his father found love again after Julia’s passing – Leonard married the much-younger Rosalind Bruce in 1912 – Julian failed in first love. And he became sick over it. He was engaged to Kathleen Fordham, a former "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("student from Prior’s Field School, but over the years he felt far more obligation than desire; suffocatingly so, and the long engagement was broken off in 1913. Impossibly difficult for her, for him this was a trauma that precipitated a first hospitalization for depression.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("As low as it was possible to be, struck down by circumstance and the melancholy inherited from his grandfather, Julian finally reemerged and rallied, and headed back to Houston and Rice Institute duties in 1914, by way of Thomas Hunt Morgan’s already famous fruit fly laboratory in New York: genetics was being born there. Julian’s commitment to Rice was on-again and off-again, coming and going between 1912 and 1916. It was a messy and short-lived appointment, not just because of the Great War, but partly so. In no small measure through Aunt Mary Ward’s patriotic urging, even shaming, by September 1916 he resigned, enlisted back in England and began war work at the Censor’s Office."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2040",
      "id": "id_2039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Julian had an easy war compared to most. His personal battles preceded it, though he reflected later that having ‘breathed the international atmosphere of Science’, and having learned important new biology in German and Italian, as well as British and American, laboratories, he felt intensely compromised by wartime allegiances. It all turned him into an anti-nationalist. Nationalism was an offence to him, and he was shocked when he first heard an American declaring, ‘My country, right or wrong’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2038",
      "id": "id_2037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Nonetheless, he served, unlike some in his biology circle who conscientiously objected. If anything, the war for Julian Huxley was social and productive. He met all kinds of people at Aldershot and had remarkably good leaves from duty. The summer of 1917, for example, was spent climbing at Lake Ogwen, north Wales. There, while US troops were arriving in France and George V changed the family name to Windsor, Julian read "), _c('em', [_vm._v("Abelard and Heloïse")]), _vm._v(" in the evenings to improve his French, though the combination of romance and tragedy can’t possibly have elevated his mental health."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2036",
      "id": "id_2035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Later that summer Julian was a guest of Lady Ottoline Morrell at Garsington Manor, near Oxford. Garsington was a home, a centre, for English cultural modernism, and Ottoline Morrell a highly unconventional patron of new-generation writers and artists. D. H. Lawrence, Virginia Woolf, T. S. Eliot and Katherine Mansfield were all hosted and nurtured there. So was Aldous Huxley, who perhaps ungenerously "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("satirized both Morrell and Garsington in his debut novel, "), _c('em', [_vm._v("Crome Yellow")]), _vm._v(" (1921). Morrell’s household and circle were young, culturally adventurous, avant-garde, experimentalist. By introducing his elder brother Julian, Aldous brought him into a sexually and emotionally charged time and place. Aldous met the Belgian refugee Maria Nys at Garsington, whom he married in 1919. Julian was taken by Swiss Juliette Baillot.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Marie Juliette Baillot was not at Garsington as an artist, however. Rather she was governess to Ottoline Morrell’s daughter, also, as it happened, named Julian. Like any Victorian governess – real or literary – early twentieth-century governesses like Juliette were part of households, but precariously so. They were in between family and service, salaried but special. At Garsington, Juliette Baillot was neither a guest nor a host, and yet her artistic sensibilities (she later sculpted and wrote superbly) recommended her for such highly unusual sociability. She later recalled her naivety about the Garsington lifestyle and sexual arrangements, and she did not find it an easy place, though her devotion to, and long friendship with, Ottoline Morrell was grounded there."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2034",
      "id": "id_2033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" She served as a kind of muse for Morrell and her camera. Like many others at Garsington Manor in those years, Juliette Baillot was captured nude, many photographs now held by the National Portrait Gallery, London. Juliette and Julian married in July 1919. Their friend H. G. Wells called them the ‘Huxleyettes and Huxleys’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2032",
      "id": "id_2031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("That Julian and Aldous were now married to these two modernist women – one a participant in early twentieth-century aesthetic nudity, the other a Belgian bisexual beauty – signals a massive generational shift in the Huxley world, as in the wider world. If Thomas Henry Huxley had lived through an era of political and religious dissent, his grandsons Aldous and Julian lived in an era of modernist cultural and artistic dissent. As young boys they may have learned from the theological morality tales that Aunt Mary wrote, but this Garsington milieu produced the erotic "), _c('em', [_vm._v("Lady Chatterley’s Lover")]), _vm._v(" (Lawrence inspired by Ottoline Morrell), as well as the more stylistically adventurous modernist writing of Mansfield, Woolf and Eliot. Aldous was also experimenting with form and structure.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("The great change was embodied in, and displayed by, the generational couples. Thomas Henry Huxley had chosen religious and earnest "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Henrietta, who underwrote her husband’s public sphere theological controversy with studied domestic sphere propriety, convention and personal faith. They were a patriarch and a matriarch occupying conventional gender roles. The outer extent of Henrietta’s public unconventionality was her Sunday ‘tall teas’, which guests loved. Her private unconventionality – her late-discovered illegitimacy – was shameful and secret. Leonard, by contrast, had chosen a smart New Woman Julia Arnold, clever and determined, with a significant English literary pedigree. Julian and Aldous chose icons of early twentieth-century modernity and apparent sexual freedom – both continental women, Aunt Mary Ward frowned."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2030",
      "id": "id_2029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("On the surface, this line of marital and cultural descent over time shifted from the mid-Victorian Huxleys’ traditional order to the 1920s partnering of the Garsington moderns. But it turned out that gendered conventions within marriages change far less easily than, say, trends in thought over natural selection. Over a long and difficult twentieth-century marriage, Juliette Huxley née Baillot fell into a domestic and public support-and-hostess role for Julian, as outwardly conventional as Henrietta’s had been for Huxley in the nineteenth century, if more contextually exciting: less St John’s Wood and more Nairobi and Paris. As Julian and Juliette’s relationship unfolded, a freedom to occupy and satisfy different sexual attractions and expressions was by agreement afforded to both of them, but in practice taken up by him more than her. He had long affairs that were painful to all, including to his father Leonard and brother Aldous, who routinely witnessed, intervened in and tried to short-circuit the familial dramas. Juliette suffered the emotional pain and then looked after her husband’s pain – Julian’s repeated breakdowns – all the while accompanying him in his life’s work as zoologist and writer, in the latter respect much as Henrietta Huxley had done. These women both outlived their men and managed their memories and memorials. Henrietta published Thomas Henry Huxley’s occasional poetry and his ‘Aphorisms and Reflections’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2028",
      "id": "id_2027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" Perhaps with more honesty and less default devotion, Juliette managed Julian’s memory, reputation, representation, books and papers after his death in 1975. And she recalled their married life with brutal honesty in her own elegant autobiography. It was the middle-generational couple who were different; Leonard and Julia. In founding and running her "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("own unconventional and highly successful girls’ school, Julia pursued a career and an enterprise parallel to Leonard’s own work in the educational then literary and publishing world. Together they modelled a new possibility for paired men and women, even as they reproduced and raised the next generation of Huxleys into both science and letters.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "C292"
  }, [_vm._v("MEN AND WOMEN OF LETTERS")]), _vm._v(" "), _c('p', {
    staticClass: "P25"
  }, [_vm._v("The Huxleys are remembered as a scientific dynasty, but they are at least as significant as a literary family. They wrote in multiple genres and for different audiences, in private and in public. That the Arnolds grafted onto the Huxleys in the middle generation, meant that this became a conjoined family of highly regarded literary figures – Matthew Arnold, Aldous Huxley, Mary Augusta Ward – and of essayists, memoirists and science writers – Thomas Henry, Leonard and Julian. More privately, though still intermittently in published form, all of the Huxleys were poets. This was a family of professional wordsmiths.")])]), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Thomas Henry and Julian were what we now call ‘science communicators’ and were unquestionably the founding masters. They both wrote in a highly skilled manner, but also in a manner that paid the bills, drawing income from their pens and typewriters. Grandfather and grandson wrote in obviously different cultural, political and technical contexts, and in diverse media: Julian worked in radio, television and film, for example, as well as in print. But in other respects, their public communication of zoology, evolutionary ideas, ethics, religion and science were similar. They both undertook private lecture tours. Julian’s US lecture tours were exhausting, he thought, ‘but well paid’."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2026",
      "id": "id_2025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" They both turned their talks into pamphlets, magazine articles and short books for popular consumption. Their journalistic essays were published across all manner of outlets, from Huxley’s assessment of the "), _c('em', [_vm._v("Origin of Species")]), _vm._v(" in "), _c('em', [_vm._v("Westminster Review")]), _vm._v(" in the 1860s to Julian’s well-paid catastrophizing of world population growth for "), _c('em', [_vm._v("Playboy")]), _vm._v(" in the 1960s."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2024",
      "id": "id_2023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" They both wrote what came to be called ‘text books’, as well as high-level and highly proficient philosophical studies about the human and natural world. Speaking on the BBC, Julian later called his "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("grandfather, quite rightly, a ‘master of English prose’, although Aldous’s assessment was more qualified."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2022",
      "id": "id_2021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Thomas Henry Huxley was raised – or really raised himself – on a literary and philosophical as well as a natural history canon. For his polymath generation, these were indistinct genres, combining ways of knowing the world in which science had not yet fully separated from philosophy, classics, literature and theology. He inherited also an early nineteenth-century genre of commentary via the essay. A commercial shift in the publishing industry had taken place, from books to those great Victorian periodicals: "), _c('em', [_vm._v("The Fortnightly Review")]), _vm._v(", "), _c('em', [_vm._v("The Nineteenth Century")]), _vm._v(", "), _c('em', [_vm._v("Westminster Review")]), _vm._v(" and the literary "), _c('em', [_vm._v("Cornhill")]), _vm._v(" magazine that Leonard was eventually to edit. The looming Victorian historian and essayist Thomas Carlyle might have bemoaned this new marriage of literature and commerce,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2020",
      "id": "id_2019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" but for entrepreneurial and hard-working Huxley it was ideal; it was his supplementary living.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("He wrote constantly for periodicals to enhance a salary of £400 a year. Henrietta remembered that while they had to ‘economize in every way’, especially with more children, they would have been ‘in a sore plight’ had it not been for the writing."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2018",
      "id": "id_2017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" As soon as Huxley took on the job at the School of Mines, he took on ‘lectures to working men’ as well. These were lecture courses – typically a suite of six – with an affordable entrance fee. ‘Six Lectures on Fossils’, for example, ‘what they are and what conclusions may be drawn from them’. The Gilchrist Fund supported some of these lectures, which were enormously popular, typically over-filling the London Mechanics’ Institute Hall in Chancery Lane."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2016",
      "id": "id_2015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" And then he was able to capitalize on this and rework much of the material into books and pamphlets, "), _c('em', [_vm._v("Lectures on the Elements of Comparative Anatomy")]), _vm._v(" (1864), for example."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2014",
      "id": "id_2013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("While the elder Huxley drew a base salary from the Royal School of Mines, his grandson was far more dependent on publication, indeed for much of his life solely so. Julian drew salaries from his early but intermittent academic posts – at Oxford, at Rice University, at Kings College, London – then from the Zoological Society of London in the 1930s, and for a short post-war period as director of Unesco in Paris. But otherwise, he supported himself, Juliette and their two sons entirely as a science communicator: a lecturer, broadcaster, non-fiction writer and sometime filmmaker.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("If they were ever short on ideas, the later generations found they could trade on Thomas Henry’s fame and his notoriety surrounding the Darwinian controversies over the 1860s and 1870s. Leonard and then Julian could both rely on retelling and reselling a Huxley family story, and many times over. Leonard started the tradition, the first of the generations to draw a full income from the literary world, beginning, sensibly enough, with "), _c('em', [_vm._v("Life and Letters of Thomas Henry Huxley")]), _vm._v(" in two volumes. His household was literally counting on it. In 1899, when Leonard was still assistant master at Charterhouse, Julia Arnold looked at the account books and anticipated £200 for "), _c('em', [_vm._v("Life & Letters")]), _vm._v(", even as she was asking Mary Ward for a further loan."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2012",
      "id": "id_2011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" On its success, Leonard turned to his wife’s family, editing "), _c('em', [_vm._v("Thoughts on Education Drawn from the Writings of Matthew Arnold")]), _vm._v(" (1912), and then others of his father’s circle, including the "), _c('em', [_vm._v("Life and Letters of Sir Joseph Dalton Hooker")]), _vm._v(" in two volumes (1918)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2010",
      "id": "id_2009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" A little more emboldened, he later presented himself in the public literary domain, with "), _c('em', [_vm._v("Anniversaries")]), _vm._v(" (1920), a collection of his own superior poems, unmediated by famous forebears, though sometimes about them. If Leonard published accounts of his father, Julian did the same in print and as broadcasts, all authorized by his own growing stature in science. Winding up his own father’s study after Leonard’s death in 1933, Thomas Henry’s 1840s "), _c('em', [_vm._v("Rattlesnake")]), _vm._v(" diary was miraculously uncovered among dishevelled papers. It had masqueraded for all those years as an account book and is now treasured in the Imperial College archives."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#page_430",
      "id": "id_2008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" Julian published the diary in 1935 and received royalties for years.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("We might recall Aldous as the Huxley man of letters and Julian the man of science, yet both brothers were professional authors. As a schoolboy, Julian was recommended for scholarships on the grounds both of exemplary understanding of zoological principles and the fact that ‘his power of writing good English is exceptional’. His only fault was ‘a tendency to think himself infallible’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2007",
      "id": "id_2006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" (A curious assessment, since not much later, Julian confessed about Eton ‘I used to weep on slight provocation; & was bullied.’)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2005",
      "id": "id_2004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" Julian was a writer in his father’s image, and a science wordsmith in his grandfather’s image. He had a marked talent as a non-fiction writer, but far less successfully experimented with science fiction."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2003",
      "id": "id_2002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" In the 1930s he tried the novel form as a container for the signature Huxley thematic: ‘man’s place in nature’, "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("eighty years after Thomas Henry Huxley’s best-known book of that title appeared. Julian’s version came out as ‘Man’s Place in the Universe’, and he tried too hard to shoehorn his rarified scholarly ideas into an unpublished novel set in Oxford parlours: the device was Aunt Mary’s convention of polemical instruction set out for the reader through drawing-room conversation."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_2001",
      "id": "id_2000",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" But he couldn’t control it. Over-long drafts morphed into disorganized sets of his own reflections on the ‘uniqueness of man’, Julian’s enduring refrain. He learned that he was a more proficient essayist and poet than novelist, and that Aldous was the right one to continue the Arnold fiction-writing family tradition, if in modernist form.")]), _vm._v(" "), _c('p', {
    staticClass: "C279"
  }, [_vm._v("These Huxleys were all poets. They composed verse both to, and about, one another. Thomas Henry Huxley’s ‘From Shanklin’ recalled his many years with Henrietta ("), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_34"
    }
  }, [_vm._v("figure 1.9")]), _vm._v("):")]), _vm._v(" "), _c('p', {
    staticClass: "C302"
  }, [_vm._v("March 1, 1887")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("DEAR wife, for more than thirty years")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("Have you and I, hand clasped in hand,")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("Sometimes all smiles, sometimes in bitter tears,")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("Wended our way through the strange land")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("Of living men; until with silvering hair,")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("And graver mien and steps more slow,")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("Adown the strand of age we fare")]), _vm._v(" "), _c('p', {
    staticClass: "C297"
  }, [_vm._v("To the still ocean, out beyond time’s flow.")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("True wife, housemother, worn with many cares,")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("Love’s afterglow shall brighten all the years")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("That yet are ours; and closer still shall be our clasp")]), _vm._v(" "), _c('p', {
    staticClass: "C297"
  }, [_vm._v("Of hands, until they nerveless fall and cease to grasp."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1999",
      "id": "id_1998",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "P25"
  }, [_vm._v("Henrietta responded with more verse than her husband; she had more time on those hands, as well as a devotion that had to be caught and put down. She had two devotions really: one to her husband and another to God. With regard to the first, she wrote poems of love and anguish as early as their long, separated engagement in the 1840s and early ’50s. One was inspired by her passage from Australia to England in 1855. Finally, she was going home. As she approached the English coast, she banished the Southern Cross. ‘I will not look South any longer, / But I will look to the North . . . Be my beacon, the North Pole star / Oh my soul! take thy leave of the Cross.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1997",
      "id": "id_1996",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" While Huxley’s poem was a private token, Henrietta eventually published hers. First bound in her own notated typescript, then privately printed in 1899, she finally published her own, along with three of Huxley’s, in 1913. It was a memorial to their life together, but her inclination towards writing predated life with Huxley. A journal Henrietta kept in her twenties indicates a passing ambition ‘to be famous as a poetess’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1995",
      "id": "id_1994",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" She wrote stanzas of grief and ecstasy, and of Moravian-inspired religious rapture. Floods of emotion transformed into sometimes saccharine verse, marking family joys and crises, as well as a nature-oriented piety. Mary Ward loved Henrietta Huxley and affectionately called her, like all the kith and kin, ‘Moo’. But this didn’t mean she loved her poetry: ‘of little or no technical merit, but raised occasionally by sheer intensity of feeling . . . into something very near the real thing’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1993",
      "id": "id_1992",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Mercifully, it was a posthumous assessment. Leonard inherited a capacity and inclination to verse from both of his parents and passed on the craft of poetry and the expectation that it be mastered, in the form of verse itself. ‘Poets to Be’ was about, and directed to, his precious sons."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1991",
      "id": "id_1990",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('div', {
    staticClass: "C226"
  }, [_c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "html/images/74_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.9: Thomas Henry and Henrietta Huxley, 1882.")])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("This eloquent family traded their compositions within and between generations, sometimes for critique, sometimes as sentimental tokens or special-occasion iambic pentameter gifts. In 1910 Julian wrote ‘Eastbourne Days’ about his grandmother, grandfather and their retirement house that the grandchildren visited so often. Charming, Henrietta complimented him. ‘It moved me deeply in its expression of love for me.’"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1989",
      "id": "id_1988",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(" Julian had recently excelled himself, winning the Newdigate prize for English verse at Oxford, following Great Uncle Matthew Arnold, awarded in 1843. The prize was a significant recognition of Julian Huxley’s mastery, and ‘Holyrood’ was published in 1908, an Edinburgh-inspired reflection on the regal and common spirits inhabiting the abbey-turned-palace-turned-ruin."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1987",
      "id": "id_1986",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" Grandmother Henrietta wrote from Eastbourne to congratulate him. ‘If only Pater could have lived on and know of your success this day.’ Would he like all Pater’s books, she was motivated to ask?"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1985",
      "id": "id_1984",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" Her eight children meant that there was a good swathe of grandchildren to choose from, but Henrietta already had her eye on Julian as the Inheritor.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Leonard, Julia and their offspring sometimes made light of their ‘pomes’. But in truth they took the craft very seriously. Julia – educationally and chromosomally steeped in English literature – offered frank commentary on another of Julian’s. ‘Leave out verse 2’, she recommended, ‘it gives too much detail to your simile.’"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1983",
      "id": "id_1982",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" Poetry was a technical enterprise, as the younger generation learned not just from their Huxley father and Arnold mother, but also from the great living literary figure in the extended family, Mary Augusta Ward. Accounts of the Huxleys – perhaps especially, of Aldous – tend to presume the special significance of Uncle Matthew Arnold. But he had died in 1888 and was unknown to Julian and Aldous, even if they read his work. It was Mary Augusta Ward née Arnold who was the major lifetime influence. She was a famous, learned and professional storyteller, and a bestselling one in Britain and even more so in the United States. Even her now lesser-known novels were fantastically successful. "), _c('em', [_vm._v("Lady Rose’s Daughter")]), _vm._v(" (1903), for example, had a first print run of 52,000 in the US alone."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1981",
      "id": "id_1980",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('em', [_vm._v("Robert Elsmere")]), _vm._v(" (1888), "), _c('em', [_vm._v("Marcella")]), _vm._v(" (1899), "), _c('em', [_vm._v("The Marriage of William Ashe")]), _vm._v(" (1905), right through to wartime novels such as "), _c('em', [_vm._v("Eltham House")]), _vm._v(" (1915) and "), _c('em', [_vm._v("The War and Elizabeth")]), _vm._v(" (1918) signalled one of the most prolific novel-writing careers of the period. She was a literary critic – of Austen, of the Brontës, of Keats – and but for the happenstance of her gender she could and should have been a professor of literature like her father. She would have made a far better one.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Julia sent her children’s juvenilia to Mary for comment."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1979",
      "id": "id_1978",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" Aunt Mary routinely passed on high-level, technical advice and uncompromising critique to her nephews Julian, Trev and Aldous. And Julian continued to seek her literary advice as a young adult. They travelled together to Florence in 1910, with Julian newly minted from Oxford. She acculturated him in things Italian, and from Naples he enclosed his latest ‘pome’, his magnum opus he called it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1977",
      "id": "id_1976",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" She was forthright in her response. ‘A great deal of it is charming verse. Flexible & graceful, some passages particularly good . . . But if I am to be frank I think its deficit is its subject, or rather its point wh. seems to me really not a point.’ She instructed him philosophically. ‘I have been thinking over it in connection with William James’s “Pragmatism” wh. I have just finished . . . the strangest attempt at a philosophic unification I ever read.’ She sent him back to the German canon: ‘In your spare moments if you haven’t already read "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("them – get and read Eckermann’s Conversations with Goethe. They contain all wisdom and they are particularly wise on subject and composition.’"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1975",
      "id": "id_1974",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")]), _vm._v(" Mary Ward gave Julian advice on his prose as well. ‘There are a few sentences that seem to want combing out a little,’ she wrote of an early article in "), _c('em', [_vm._v("Cornhill")]), _vm._v(" magazine, ‘but it certainly gives one great hope of your future as a writer.’ She even imagined her young nephew Julian to be a philosophical writer: ‘We want an English Bergson – do you feel inclined to fill the niche!’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1973",
      "id": "id_1972",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" The exclamatory punctuation – not a question mark – was hardly immaterial to the novelist. Mary Ward might well have been urging her thoughtful nephew on quite sincerely. Indeed, Julian dedicated his early book "), _c('em', [_vm._v("The Individual in the Animal Kingdom")]), _vm._v(" (1912) to Henri Bergson, whose "), _c('em', [_vm._v("Creative Evolution")]), _vm._v(" (1907) and notion of "), _c('em', [_vm._v("élan vital")]), _vm._v(", the idea of a vital force, or impulse for life inherent in all organisms, then held strong attachments."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1971",
      "id": "id_1970",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" Far too magical an idea for his grandfather.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Mary Ward was important to her nephews Julian, Trev and Aldous, whom she certainly perceived and valued as literary Arnolds as much as naturalist Huxleys. In return, they read her novels diligently. Perhaps her most famous and enduring is "), _c('em', [_vm._v("Robert Elsmere")]), _vm._v(" (1888), drawn from her own father’s – Julian and Aldous’s other grandfather’s – doctrinal crises and written in large part from Peper Harow, Surrey, adjacent to Godalming, where Mary Ward and her own family spent six consecutive summers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#page_431",
      "id": "id_1969",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" Aldous consumed his aunt’s novels too, despite his poor eyesight: he had developed keratitis at Eton. In 1911 Julian wrote to his Huxley grandmother that Aldous’s eyes were looking better, ‘on the upgrade’, and that he was reading Aunt Mary’s latest, "), _c('em', [_vm._v("The Marriage of William Ashe")]), _vm._v(". It was a bestseller in the United States and had been serialized in "), _c('em', [_vm._v("Harper’s")]), _vm._v(" magazine. Aldous was reading it in Braille."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1968",
      "id": "id_1967",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "C292"
  }, [_vm._v("INTROSPECTION: HUXLEY SELF-PORTRAITURE")]), _vm._v(" "), _c('p', {
    staticClass: "P25"
  }, [_vm._v("There is no question that generations of Huxleys presented themselves to the world through the printed word. They also did so in visual art, in countless drawings, paintings, photographs and sculptures. Portraits and self-portraits saturated the Huxley universe.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Thomas Henry Huxley was fully engaged with explorations of the self, of character, of sensation. Yet he hardly displayed that other Victorian virtue, studied selflessness. His mature home was filled with images of himself, not just in oil, but in marble and terracotta. He greeted himself every time he ascended his stairs (")]), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_39"
    }
  }, [_vm._v("figure 1.10")]), _vm._v("). Still, this Huxley "), _c('em', [_vm._v("was")]), _vm._v(" striking; a favourite for both sombre portraitists and piercing caricaturists. His black eyes, his signature sideburns, his confident carriage all transferred well into oil, ink, pencil and marble. He loved being public.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("If Huxley liked to look at himself, taken with his own visage, Henrietta was a student of other faces: ‘nothing delights me so much as dwelling on physiognomy, I mentally trace each feature with my invisible pencil.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1966",
      "id": "id_1965",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" Like most educated or self-educated Victorians, they both sketched and painted. Huxley made quite a bit of his own talent, a piece of self-aggrandizement that various biographers have repeated, but in truth his sketches and watercolours are ordinary enough by the standards of his time and his milieu. Many not even that. And yet art and talent to observe and represent faces certainly passed to the next generation, including the tendency to represent their Huxley selves. Daughter Marian – Mady – could put strong emotion into and onto her highly accomplished portraits, especially those of her striking father, who sat for her many times ("), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_40"
    }
  }, [_vm._v("figure 1.11")]), _vm._v("). They shared a melancholy.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Mady studied at the Slade School of Fine Art, where she met and then married John Collier in 1879. This was a marriage of the late Victorian era’s best portraitist into the Huxley dynasty, twice over. Perhaps John Collier’s most intimate Huxley portrait was of his wife Marian ("), _c('span', {
    attrs: {
      "href": "#/html/12_3__Malady_of_Thought__Huxley_Min#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("figure 3.4")]), _vm._v("). Her Huxley melancholy is caught, just as she caught her father’s. In a reverse gesture, she depicted him painting a portrait of her."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1964",
      "id": "id_1963",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" The layers of Huxley introspection were endless.")]), _vm._v(" "), _c('p', {
    staticClass: "P29"
  }, [_vm._v("Through Collier’s own relentless interest in generations of Huxleys, they became, if anything, over-represented in oil. His style was pre-Raphaelite: rich and thick. In fact, John Collier couldn’t stop painting the Huxleys. He painted Henrietta and offered a delicate miniature of Margaret Huxley to Leonard and Julia ("), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_23"
    }
  }, [_vm._v("figure 1.7")]), _vm._v("). As an elderly man, long married to Ethel, he wanted to paint his nephew Julian and H. G. Wells together, caught in the process of writing "), _c('em', [_vm._v("The Science of Life")]), _vm._v(", but he couldn’t pin down the sought-after Wells."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1962",
      "id": "id_1961",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" So he considered one just of Julian, the writer: ‘My crude idea of a portrait of you is to express you in writing at a table covered with books & documents & litter generally. I have a morbid hankering after a skeleton in the background.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1960",
      "id": "id_1959",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" Any skeleton in the Huxley context was a reference to the long-dead patriarch. Collier also sought out Juliette Huxley to sit for him several times – he was not satisfied that he had caught ‘her elusive charm’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#id_1958",
      "id": "id_1957",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('div', {
    staticClass: "C226"
  }, [_c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "html/images/79_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.10: Huxley greeted himself every time he climbed the stairs.")])])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('div', {
    staticClass: "C226"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "html/images/80_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.11: "), _c('em', [_vm._v("Thomas Henry Huxley")]), _vm._v(" by Marian Collier (née Huxley).")])])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('p', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Most famously, Collier painted perhaps the most recognizable images of the naturalist friends Darwin and Huxley: Darwin humbly holding his hat, Huxley grandiosely holding a skull. Etchings of the pair still grace a Huxley-Darwin home (")]), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_42"
    }
  }, [_vm._v("figures 1.12")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_43"
    }
  }, [_vm._v("1.13")]), _vm._v("). Thomas Henry Huxley loomed over all his descendants, especially Julian Huxley. Collier’s oil of Grandfather hung for decades in his library at 31 Pond Street, Hampstead, the home renovated by architect Ernst Freud, Sigmund’s son. Julian gladly announced his genealogy via this portrait, for "), _c('em', [_vm._v("Life")]), _vm._v(" magazine and for the world. He was the Inheritor.")]), _vm._v(" "), _c('div', {
    staticClass: "C226"
  }, [_c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "html/images/82_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.12: Etching by Leopold Flameng of John Collier, "), _c('em', [_vm._v("Charles Darwin")]), _vm._v(", 1883.")])])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('div', {
    staticClass: "C226"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('p', {
    staticClass: "C225"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "html/images/83_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "C234"
  }, [_vm._v("Figure 1.13: Etching by Leopold Flameng of John Collier, "), _c('em', [_vm._v("Thomas Henry Huxley")]), _vm._v(", 1885.")])])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7679d827","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/10_1__Generations__The_Huxleys__182.vue
// module id = 84
// module chunks = 0